/** 日期格式 */
export enum DateFormat {
  /** YYYY年MM月DD日 */
  LOCAL = 0,

  /** YYYY-MM-DD */
  HYPHEN = 1,

  /** YYYY/MM/DD */
  SLASH = 2
}

/** 日期格式列表 */
export const DateFormatList = [
  {
    label: 'YYYY年MM月DD日',
    value: DateFormat.LOCAL,
    format: 'yyyy年MM月dd日'
  },
  {
    label: 'YYYY-MM-DD',
    value: DateFormat.HYPHEN,
    format: 'yyyy-MM-dd'
  },
  {
    label: 'YYYY/MM/DD',
    value: DateFormat.SLASH,
    format: 'yyyy/MM/dd'
  }
]
